import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const FilteringLargeIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5 4C4.44772 4 4 4.44772 4 5V8.5H28L28 5C28 4.44772 27.5523 4 27 4H5ZM26.5858 10.5H5.41421L12.7071 17.7929C12.8946 17.9804 13 18.2348 13 18.5V26.4384C13 27.089 13.6114 27.5664 14.2425 27.4086L18.2425 26.4086C18.6877 26.2973 19 25.8973 19 25.4384V18.5C19 18.2348 19.1054 17.9804 19.2929 17.7929L26.5858 10.5ZM2 5C2 3.34315 3.34315 2 5 2H27C28.6569 2 30 3.34315 30 5L30 9.5C30 9.76522 29.8946 10.0196 29.7071 10.2071L21 18.9142V25.4384C21 26.8151 20.0631 28.015 18.7276 28.3489L14.7276 29.3489C12.8342 29.8222 11 28.3902 11 26.4384V18.9142L2.29289 10.2071C2.10536 10.0196 2 9.76522 2 9.5V5Z"
    fill="currentColor"
  />,
  "FilteringLargeIcon"
);
(FilteringLargeIcon as React.ComponentType).defaultProps = {
  viewBox: "0 0 32 32",
};
